import React from 'react';
import { Card, CardContent, Typography, Box, Button, Chip } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface DashboardOverviewProps {
  id: string;
  name: string;
  description: string;
  organizationName: string;
  organizationId: string;
}

const DashboardOverview: React.FC<DashboardOverviewProps> = ({ id, name, description, organizationName, organizationId }) => {
  const navigate = useNavigate();

  const handleEditClick = () => {
    navigate(`/campaigns/${organizationId}/${id}`);
  };

  const displayName = name || 'Unnamed Campaign';

  return (
    <Card
      sx={{
        boxShadow: 3, // Box shadow for card effect
        borderRadius: 2, // Rounded corners for card effect
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <Box mb={1}>
          <Chip
            label={organizationName}
            size="small"
            color="primary"
            variant="outlined"
            sx={{ mb: 1 }}
          />
        </Box>

        <Typography variant="h5" gutterBottom>
          {displayName}
        </Typography>

        {description !== displayName && (
          <Typography variant="body2" color="textSecondary" gutterBottom>
            {description}
          </Typography>
        )}

        <Box mt="auto" display="flex" justifyContent="flex-end">
          <Button variant="contained" color="primary" onClick={handleEditClick}>
            MANAGE
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default DashboardOverview;
